import type { IconGlyph } from '../icon';

import { iconBatchThick } from './batch-thick';

/**
 * Tractie `batch` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/batch.jsx`.
 * Verbatim copy of the SVG `d` attributes, 3 paths in source order.
 */
export const iconBatch: IconGlyph = {
  name: 'batch',
  path: [
    'M18.5 4h-9C8.67 4 8 4.67 8 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5m.5 10.5c0 .28-.22.5-.5.5h-9c-.28 0-.5-.22-.5-.5v-9c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5z',
    'M7 16.5V6.09c-.58.21-1 .76-1 1.41v9c0 .83.67 1.5 1.5 1.5h9c.65 0 1.21-.42 1.41-1H7.5c-.28 0-.5-.22-.5-.5',
    'M5 18.5V8.09c-.58.21-1 .76-1 1.41v9c0 .83.67 1.5 1.5 1.5h9c.65 0 1.21-.42 1.41-1H5.5c-.28 0-.5-.22-.5-.5',
  ],
  selected: iconBatchThick,
};
